import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pt-24 -md:pt-16 h-screen" }
const _hoisted_2 = { class: "px-6 py-5 h-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Filtrar por data", -1)
const _hoisted_4 = { class: "flex gap-12 -lg:mb-5 mb-2 items-center" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-5 pb-5" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_7 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_8 = {
  key: 0,
  class: "leading-none py-2 text-xl text-brand-dark"
}
const _hoisted_9 = {
  key: 1,
  width: "38",
  height: "38",
  src: "/colorful-loading.gif"
}
const _hoisted_10 = { class: "font-bold py-2 text-lg text-gray-600" }
const _hoisted_11 = {
  key: 1,
  class: "text-center"
}
const _hoisted_12 = {
  key: 0,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_13 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "leading-none py-2 text-xl text-brand-dark" }, "Falha", -1)
const _hoisted_15 = { class: "font-bold text-lg text-gray-600" }
const _hoisted_16 = {
  ref: "tooltip",
  "data-tippy-content": "Receita em Taxas dos Estabelecimentos Comerciais = Total de transações * Taxa de Mediação EC"
}
const _hoisted_17 = {
  key: 1,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_18 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_19 = {
  key: 0,
  class: "leading-none py-2 text-xl text-brand-dark"
}
const _hoisted_20 = {
  key: 1,
  width: "38",
  height: "38",
  src: "/colorful-loading.gif"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold py-2 text-lg text-gray-600" }, " Total de Transações ", -1)
const _hoisted_22 = {
  key: 0,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_23 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "leading-none py-2 text-xl text-brand-dark" }, "Falha", -1)
const _hoisted_25 = { class: "font-bold text-lg text-gray-600" }
const _hoisted_26 = {
  ref: "tooltip",
  "data-tippy-content": "Receita em Taxas dos Estabelecimentos Comerciais = Total de transações * Taxa de Mediação EC"
}
const _hoisted_27 = {
  key: 1,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_28 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_29 = {
  key: 0,
  class: "leading-none py-2 text-xl text-brand-dark"
}
const _hoisted_30 = {
  key: 1,
  width: "38",
  height: "38",
  src: "/colorful-loading.gif"
}
const _hoisted_31 = { class: "font-bold text-lg text-gray-600" }
const _hoisted_32 = {
  ref: "tooltip",
  "data-tippy-content": "Receita em Taxas dos Estabelecimentos Comerciais = Total de transações * Taxa de Mediação EC"
}
const _hoisted_33 = {
  key: 0,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_34 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "leading-none py-2 text-xl text-brand-dark" }, "Falha", -1)
const _hoisted_36 = { class: "font-bold text-lg text-gray-600" }
const _hoisted_37 = {
  ref: "tooltip",
  "data-tippy-content": "Receita em Taxas dos Estabelecimentos Comerciais = Total de transações * Taxa de Mediação EC"
}
const _hoisted_38 = {
  key: 1,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_39 = { class: "text-sm w-3/4 flex-shrink-0 text-left" }
const _hoisted_40 = {
  key: 0,
  class: "leading-none py-2 text-xl text-brand-dark"
}
const _hoisted_41 = {
  key: 1,
  class: "",
  width: "38",
  height: "38",
  src: "/colorful-loading.gif"
}
const _hoisted_42 = { class: "font-bold py-2 text-lg text-gray-600" }
const _hoisted_43 = {
  ref: "tooltip2",
  "data-tippy-content": "Custo em Taxas da Software House = Total de transações * Taxa de Negociação SH"
}
const _hoisted_44 = {
  key: 0,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_45 = { class: "text-sm w-3/4 flex-shrink-0" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", { class: "leading-none py-2 text-xl text-brand-dark" }, "Falha", -1)
const _hoisted_47 = { class: "font-bold text-lg text-gray-600" }
const _hoisted_48 = {
  ref: "tooltip",
  "data-tippy-content": "Receita em Taxas dos Estabelecimentos Comerciais = Total de transações * Taxa de Mediação EC"
}
const _hoisted_49 = {
  key: 1,
  class: "flex justify-between items-center w-full p-5"
}
const _hoisted_50 = { class: "text-sm w-3/4 flex-shrink-0 text-left" }
const _hoisted_51 = {
  key: 0,
  class: "leading-none py-2 text-xl text-brand-dark"
}
const _hoisted_52 = {
  key: 1,
  class: "justify-center align-middle",
  width: "38",
  height: "38",
  src: "/colorful-loading.gif"
}
const _hoisted_53 = { class: "font-bold py-2 text-lg text-gray-600" }
const _hoisted_54 = {
  ref: "tooltip3",
  "data-tippy-content": "Balanço Financeiro da Software House = Receita em Taxas dos EC - Custo em Taxas da SH"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomInput = _resolveComponent("CustomInput")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_CustomInput, {
          label: "Data inicial do filtro",
          type: "date",
          name: "startFilter",
          validation: _ctx.filterDateStartErrorMessage,
          value: _ctx.startFilter,
          onChange: _ctx.changeFilterDate,
          class: "col-span-6"
        }, null, 8, ["validation", "value", "onChange"]),
        _createVNode(_component_CustomInput, {
          label: "Data final do filtro",
          type: "date",
          name: "endFilter",
          validation: _ctx.filterDateEndErrorMessage,
          value: _ctx.endFilter,
          onChange: _ctx.changeFilterDate,
          class: "col-span-6"
        }, null, 8, ["validation", "value", "onChange"]),
        _createVNode(_component_PrimaryButton, {
          label: "Filtrar",
          type: "button",
          iconCustomClass: "filter brightness-0 invert",
          width: "w-full",
          class: "-lg:w-1/2 2xl:w-72 false flex flex-col space-y-1 w-full align-middle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData()))
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Card, {
          class: "col-span-12 md:col-span-4 h-40 flex items-center",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            (!_ctx.requestErrors.estabelecimentosAmount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.shop
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_7, [
                    (!_ctx.loadingEstabelecimentosAmount)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.estabelecimentos), 1))
                      : _createCommentVNode("", true),
                    (_ctx.loadingEstabelecimentosAmount)
                      ? (_openBlock(), _createElementBlock("embed", _hoisted_9))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.estabelecimentos === 1 ? 'Estabelecimento Ativo' : 'Estabelecimentos Ativos'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, " Dados inválidos ")),
            _createVNode(_component_Link, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleEstabelecimentos())),
              class: "bg-gray-100 transition duration-300 ease-in-out hover:bg-gray-300 w-full h-full border-b rounded-b p-2 pl-4 flex items-center justify-start cursor-pointer text-brand-dark",
              label: "Ver tudo"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "col-span-12 md:col-span-4 h-40 flex items-center",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            (_ctx.requestErrors.transactionSeries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", _hoisted_15, [
                      _createTextVNode(" Não foi possível buscar o total de transações pix "),
                      _createElementVNode("span", _hoisted_16, null, 512)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.fileDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_18, [
                    (!_ctx.loadingEstabelecimentosAmount)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.totalTransactions), 1))
                      : _createCommentVNode("", true),
                    (_ctx.loadingEstabelecimentosAmount)
                      ? (_openBlock(), _createElementBlock("embed", _hoisted_20))
                      : _createCommentVNode("", true),
                    _hoisted_21
                  ])
                ])),
            _createVNode(_component_Link, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleVolumetria())),
              class: "bg-gray-100 transition duration-300 ease-in-out hover:bg-gray-300 w-full h-full border-b rounded-b p-2 pl-4 flex items-center justify-start cursor-pointer text-brand-dark",
              label: "Ver tudo"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "col-span-12 md:col-span-4 h-40 flex items-center",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            (_ctx.requestErrors.totalSeries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("p", _hoisted_25, [
                      _createTextVNode(" Não foi possível buscar os dados de receita dos estabelecimentos comerciais "),
                      _createElementVNode("span", _hoisted_26, null, 512)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_28, [
                    (!_ctx.loadingTotalTransactionsValue)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(_ctx.totalCompanyTransactionsValue)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.loadingTotalTransactionsValue)
                      ? (_openBlock(), _createElementBlock("embed", _hoisted_30))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_31, [
                      _createTextVNode(" Receita em Taxas dos Estabelecimentos Comerciais "),
                      _createElementVNode("span", _hoisted_32, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-5 h-5 rounded-full mx-4 self-center",
                          icon: _ctx.faQuestionCircle
                        }, null, 8, ["icon"])
                      ], 512)
                    ])
                  ])
                ])),
            _createVNode(_component_Link, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleVolumetria())),
              class: "bg-gray-100 transition duration-300 ease-in-out hover:bg-gray-300 w-full h-full border-b rounded-b p-2 pl-4 flex items-center justify-start cursor-pointer text-brand-dark",
              label: "Ver tudo"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "col-span-12 md:col-span-4 h-40 flex items-center",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            (_ctx.requestErrors.totalSeries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("p", _hoisted_36, [
                      _createTextVNode(" Não foi possível buscar o custo em taxas da software house "),
                      _createElementVNode("span", _hoisted_37, null, 512)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_39, [
                    (!_ctx.loadingTotalTransactionsValue)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(_ctx.totalTransactionsValue)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.loadingTotalTransactionsValue)
                      ? (_openBlock(), _createElementBlock("embed", _hoisted_41))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_42, [
                      _createTextVNode(" Custo em Taxas da Software House "),
                      _createElementVNode("span", _hoisted_43, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-5 h-5 rounded-full mx-4 self-center",
                          icon: _ctx.faQuestionCircle
                        }, null, 8, ["icon"])
                      ], 512)
                    ])
                  ])
                ])),
            _createVNode(_component_Link, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleVolumetria())),
              class: "bg-gray-100 transition duration-300 ease-in-out hover:bg-gray-300 w-full h-full border-b rounded-b p-2 pl-4 flex items-center justify-start cursor-pointer text-brand-dark",
              label: "Ver tudo"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "col-span-12 md:col-span-4 h-40 flex items-center",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            (_ctx.requestErrors.softwareHouseBalanceSeries)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("p", _hoisted_47, [
                      _createTextVNode(" Não foi possível buscar o balanço financeiro da software house "),
                      _createElementVNode("span", _hoisted_48, null, 512)
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createVNode(_component_FontAwesomeIcon, {
                    class: "w-10 h-10 rounded-full mx-4 self-center",
                    icon: _ctx.sackDollar
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_50, [
                    (!_ctx.loadingTotalTransactionsValue)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(_ctx.totalSoftwareHouseBalance)), 1))
                      : _createCommentVNode("", true),
                    (_ctx.loadingTotalTransactionsValue)
                      ? (_openBlock(), _createElementBlock("embed", _hoisted_52))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_53, [
                      _createTextVNode(" Balanço Financeiro da Software House "),
                      _createElementVNode("span", _hoisted_54, [
                        _createVNode(_component_FontAwesomeIcon, {
                          class: "w-5 h-5 rounded-full mx-4 self-center",
                          icon: _ctx.faQuestionCircle
                        }, null, 8, ["icon"])
                      ], 512)
                    ])
                  ])
                ])),
            _createVNode(_component_Link, {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleVolumetria())),
              class: "bg-gray-100 transition duration-300 ease-in-out hover:bg-gray-300 w-full h-full border-b rounded-b p-2 pl-4 flex items-center justify-start cursor-pointer text-brand-dark",
              label: "Ver tudo"
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}